import * as React from "react";
import {
    IFalconConvenienceApiService,
    ISettings,
    LvToAllianzUKTransferBannerHelper,
    ProductsEnum,
    Types
} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";

interface IProps {
    product?: ProductsEnum;
    isMotorOnlyMultipolicy?: boolean;
    showTitle?: boolean;
}

interface IState {
    isBannerEnabled: boolean;
    wording: string | undefined;
}

export class LvToAllianzUKTransferBanner extends React.Component<IProps, IState> {

    @lazyInject(Types.FalconConvenienceApiService)
    protected readonly falconConvenienceApiService: IFalconConvenienceApiService;

    constructor(props: any) {
        super(props);

        this.state = {
            isBannerEnabled: false,
            wording: undefined
        }
    }

    public componentDidMount() {
        this.falconConvenienceApiService.getSettings().subscribe(
            (settings: ISettings) => LvToAllianzUKTransferBannerHelper.setBannerWidgetState(
                settings,
                (state: IState) => this.setState(state)
            )
        );
    }

    public render() {
        if (!this.state.isBannerEnabled) {
            return <></>;
        }

        let motorMargins = this.props?.product === ProductsEnum.WOLF_MOTOR ? "transfer-banner-motor" : "";
        if (this.props?.isMotorOnlyMultipolicy !== undefined) {
            motorMargins = this.props?.isMotorOnlyMultipolicy ? "transfer-banner-motor" : "transfer-multi-margins";
        }

        return (
            <div className={`banner transfer-banner ${motorMargins}`}>
                <div className="banner-text">
                    {this.props.showTitle && this.renderTitle()}
                    <p className="fs-20">
                        {this.state.wording} You can find out more information about the transfer at {' '}
                        <a className="font-weight-normal" href="https://www.allianz.co.uk/transfer" id="transfer" target="_blank">
                            www.allianz.co.uk/transfer
                        </a>.
                    </p>
                </div>
            </div>
        );
    }

    private renderTitle(): React.ReactNode {
        return (
            <p className="fs-22 mb-3"><strong>We’re planning some changes to our business</strong></p>
        );
    }

}
